import React, { useState } from 'react';
import { ConfigProvider, Layout, Menu, theme } from 'antd';
import {
  AppstoreOutlined,
  EnvironmentOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from '@ant-design/icons';
 
 
 
import CategoryManagement from './CategoryManagement';
import PincodeManagement from './PincodeManagement';
import ProductManagement from './ProductManagement.jsx';
import ComboManagement from './ComboManagement.jsx';

const { Header, Sider, Content } = Layout;

function Admin() {
  const [collapsed, setCollapsed] = useState(false);
  const [currentView, setCurrentView] = useState('categories');
  
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const menuItems = [
    {
      key: 'categories',
      icon: <AppstoreOutlined />,
      label: 'Categories',
    },
    {
      key: 'pincodes',
      icon: <EnvironmentOutlined />,
      label: 'Pincodes',
    },
    {
      key: 'products',
      icon: <EnvironmentOutlined />,
      label: 'Products',
    },
    {
      key: 'combos',
      icon: <EnvironmentOutlined />,
      label: 'Combos',
    },
  ];

  const renderContent = () => {
    switch (currentView) {
      case 'categories':
        return <CategoryManagement />;
      case 'pincodes':
        return <PincodeManagement />;
      case 'products':
        return <ProductManagement />;
      case 'combos':
        return <ComboManagement />;
      default:
        return <CategoryManagement />;
    }
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#1890ff',
          borderRadius: 8,
        },
      }}
    >
      <Layout className="min-h-screen">
        <Sider 
          trigger={null} 
          collapsible 
          collapsed={collapsed}
          width={250}
          breakpoint="lg"
          collapsedWidth="80"
          className="shadow-lg"
        >
          <div className="h-16 flex items-center justify-center">
            <h1 className={`text-white font-bold ${collapsed ? 'text-xl' : 'text-2xl'}`}>
              {collapsed ? 'FM' : 'Florist Mgmt'}
            </h1>
          </div>
          <Menu
            theme="dark"
            mode="inline"
            selectedKeys={[currentView]}
            items={menuItems}
            onClick={({ key }) => setCurrentView(key)}
          />
        </Sider>
        <Layout>
          <Header className="flex items-center bg-white px-6 shadow-sm">
            <button
              className="text-lg mr-4"
              onClick={() => setCollapsed(!collapsed)}
            >
              {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </button>
            <div className="flex-1">
              <h2 className="text-xl font-semibold text-gray-800">
                {currentView === 'categories' ? 'Category Management' : 'Pincode Management'}
              </h2>
            </div>
          </Header>
          <Content className="m-4">
            <div
              style={{
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
              }}
            >
              {renderContent()}
            </div>
          </Content>
        </Layout>
      </Layout>
    </ConfigProvider>
  );
}

export default Admin;